import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class PersianService {
  constructor(private translate: TranslateService) { }

  public isPersianNumber(number: string): boolean {
    const regexp = new RegExp('^[\u06F0-\u06F9]+$');
    return regexp.test(number);
  }

  public toPersianNumber(number: string): string {
    if (number === undefined) {
      return '';
    }
    let str = number.toString().trim();
    if (str === '') {
      return '';
    }
    str = str.replace(/0/g, '۰');
    str = str.replace(/1/g, '۱');
    str = str.replace(/2/g, '۲');
    str = str.replace(/3/g, '۳');
    str = str.replace(/4/g, '۴');
    str = str.replace(/5/g, '۵');
    str = str.replace(/6/g, '۶');
    str = str.replace(/7/g, '۷');
    str = str.replace(/8/g, '۸');
    str = str.replace(/9/g, '۹');
    return str;
  }

  public toEnglishNumber(number: string): number {
    if (number === undefined) {
      return NaN;
    }
    let str = number.toString().trim();
    if (str === '') {
      return NaN;
    }
    str = str.replace(/۰/g, '0');
    str = str.replace(/۱/g, '1');
    str = str.replace(/۲/g, '2');
    str = str.replace(/۳/g, '3');
    str = str.replace(/۴/g, '4');
    str = str.replace(/۵/g, '5');
    str = str.replace(/۶/g, '6');
    str = str.replace(/۷/g, '7');
    str = str.replace(/۸/g, '8');
    str = str.replace(/۹/g, '9');
    return Number(str);
  }
  public wordify(input:string | number, level: number = 0):string{

    if (input === null) {
      return '';
    }
  
    let num: number = parseInt(this.toEnglishDigits(input));
  
    // convert negative number to positive and get wordify value
    if (num < 0) {
      num = num * -1;
      return 'منفی ' + this.wordify(num, level);
    }
    if (num === 0) {
      if (level === 0) {
        return 'صفر';
      } else {
        return '';
      }
    }
    let result = '';
    const yekan = ['یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'],
      dahgan = ['بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'],
      sadgan = [
        'یکصد',
        'دویست',
        'سیصد',
        'چهارصد',
        'پانصد',
        'ششصد',
        'هفتصد',
        'هشتصد',
        'نهصد',
      ],
      dah = [
        'ده',
        'یازده',
        'دوازده',
        'سیزده',
        'چهارده',
        'پانزده',
        'شانزده',
        'هفده',
        'هیجده',
        'نوزده',
      ];
  
    if (level > 0) {
      result += ' و ';
      level -= 1;
    }
  
    if (num < 10) {
      result += yekan[num - 1];
    } else if (num < 20) {
      result += dah[num - 10];
    } else if (num < 100) {
      result += dahgan[Math.floor(num / 10) - 2] + this.wordify(num % 10, level + 1);
    } else if (num < 1000) {
      result +=
        sadgan[Math.floor(num / 100) - 1] + this.wordify(num % 100, level + 1);
    } else if (num < 1000000) {
      result +=
      this.wordify(Math.floor(num / 1000), level) +
        ' هزار' +
        this.wordify(num % 1000, level + 1);
    } else if (num < 1000000000) {
      result +=
      this.wordify(Math.floor(num / 1000000), level) +
        ' میلیون' +
        this.wordify(num % 1000000, level + 1);
    } else if (num < 1000000000000) {
      result +=
      this.wordify(Math.floor(num / 1000000000), level) +
        ' میلیارد' +
        this.wordify(num % 1000000000, level + 1);
    } else if (num < 1000000000000000) {
      result +=
      this.wordify(Math.floor(num / 1000000000000), level) +
        ' تریلیارد' +
        this.wordify(num % 1000000000000, level + 1);
    }
  
    return result;
  }
  public toEnglishNumberString(number: string): string {
    if (number === undefined) {
      return '';
    }
    let str = number.toString().trim();
    if (str === '') {
      return '';
    }
    str = str.replace(/۰/g, '0');
    str = str.replace(/۱/g, '1');
    str = str.replace(/۲/g, '2');
    str = str.replace(/۳/g, '3');
    str = str.replace(/۴/g, '4');
    str = str.replace(/۵/g, '5');
    str = str.replace(/۶/g, '6');
    str = str.replace(/۷/g, '7');
    str = str.replace(/۸/g, '8');
    str = str.replace(/۹/g, '9');
    return str;
  }
  toEnglishDigits(num: string | number): string {
    if (num === null || num === undefined) {
      return '';
    }
  
    if (typeof num !== 'string' || num.length === 0) return num.toString();
  
    const faDigits = '۰۱۲۳۴۵۶۷۸۹';
    const arDigits = '٠١٢٣٤٥٦٧٨٩';
    let output = '';
    for (let ipos = 0; ipos < num.length; ipos++) {
      let faIndex = faDigits.indexOf(num[ipos]);
      if (faIndex >= 0) {
        output += faIndex.toString();
        continue;
      }
      let arIndex = arDigits.indexOf(num[ipos]);
      if (arIndex >= 0) {
        output += arIndex.toString();
        continue;
      }
      output += num[ipos];
    }
    return output.replace(/,/g, '');
  }
  
}
